"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineAlert = void 0;
var react_1 = __importDefault(require("react"));
var colors_1 = require("../../themes/colors");
var utilsOolib_1 = require("../../utilsOolib");
var red = colors_1.colors.red, invertRed = colors_1.colors.invertRed, white = colors_1.colors.white, green = colors_1.colors.green, invertGreen = colors_1.colors.invertGreen, greyColor15 = colors_1.colors.greyColor15, greyColor70 = colors_1.colors.greyColor70, greyColor100 = colors_1.colors.greyColor100;
/**
 * @component Renders a inline alert component with customizable text and style.
 *
 * - The props object containing the following properties:
 * @prop {string} props.text: The text to be displayed in the inline alert.
 * @prop {'success' | 'danger' | 'neutral' | 'neutralInactive'} props.type: The type of alert to be displayed. Defaults to "neutral".
 * @prop {React.CSSProperties} props.style: Additional CSS styles to apply to the inline alert.
 * @prop {boolean} props.invert: A boolean indicating whether to invert the colors of the inline alert. Defaults to false.
 * @prop {object} props.link: An object containing the link properties: url and text. If provided, a link is rendered next to the text.
 * @return {ReactElement} The rendered inline alert component.
 */
var InlineAlert = function (_a) {
    var text = _a.text, link = _a.link, _b = _a.type, type = _b === void 0 ? 'neutral' : _b, style = _a.style, invert = _a.invert;
    var localize = (0, utilsOolib_1.useLocale)();
    var typeColor = {
        success: { normal: green, invert: invertGreen },
        danger: { normal: red, invert: invertRed },
        neutral: { normal: greyColor100, invert: white },
        neutralInactive: { normal: greyColor70, invert: greyColor15 },
    };
    return (react_1.default.createElement("h5", { style: __assign({ display: 'flex', alignItems: 'center', gap: '0.5rem' }, style) },
        react_1.default.createElement("span", { className: 'SANS_2', style: { color: typeColor[type][invert ? 'invert' : 'normal'] } }, localize(text)),
        link && (react_1.default.createElement("a", { className: 'SANS_2', style: {
                paddingLeft: '1rem',
                textDecoration: 'underline',
                color: invert ? white : greyColor100,
            }, href: link.url, target: "_blank", rel: "noopener noreferrer" }, localize(link.text)))));
};
exports.InlineAlert = InlineAlert;
